import * as React from 'react';
import { t } from 'i18next';

import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { ArticleActions } from '../../actions/ArticleActions';
import { BaseComponent } from '../BaseComponent';
import { HamburgerTab } from '../../constants/Enums';
import { LongButton } from '../LongButton';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';

interface ImportButtonState {
    isActive: boolean;
}

export class ImportButton extends BaseComponent<{}, ImportButtonState> {
    protected importInputElement: HTMLInputElement;

    constructor(props: {}) {
        super(props);
        this.openImportMenu = this.openImportMenu.bind(this);
        this.openTypicalDialog = this.openTypicalDialog.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.setImportElement = this.setImportElement.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        if (AppConfigurationStore.getState().importMenuAvailable) {
            return (
                <LongButton
                    active={(this.state.isActive)}
                    icon="insert-button"
                    shortBorder={AppConfigurationStore.getState().inApp}
                    onClick={this.openImportMenu}
                >
                    <span>{t('Import')}</span>
                </LongButton>
            );
        }
        return (
            <LongButton icon="insert-button" onClick={this.openTypicalDialog}>
                <input
                    type="file"
                    accept=".pec"
                    onChange={this.onInputChange}
                    className="open-input-element"
                    style={{ display: 'none' }}
                    ref={this.setImportElement}
                />
                <span>{t('Import')}</span>
            </LongButton>
        );
    }

    protected onInputChange(): void {
        ArticleActions.importTypical(this.importInputElement);
    }

    protected setImportElement(node: HTMLInputElement): void {
        this.importInputElement = node;
    }

    protected onChange(): void {
        this.setState({
            isActive: ViewSettingsStore.getState().hamburgerTab === HamburgerTab.IMPORT
        });
    }

    protected openTypicalDialog(): void {
        if (this.importInputElement) {
            this.importInputElement.click();
        }
    }

    protected openImportMenu(): void {
        ViewSettingsActions.changeHamburger(HamburgerTab.IMPORT);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/ImportButton.tsx